import React from "react";
import { TABLET_BREAKPOINT } from "~/hooks/useBreakpoints";

const Logo: React.FC = () => {
  return (
    <a
      aria-label="Shirtspace.com Logo"
      href="/"
      className="block h-[29px] w-[150px] md:h-[38px] md:w-[200px]"
    >
      <picture>
        <source
          media={`(min-width: ${TABLET_BREAKPOINT}px)`}
          srcSet="/frontend-assets/images/logo_desktop.svg"
        />
        <img
          src="/frontend-assets/images/logo_mobile.svg"
          className="md:block"
          alt="ShirtSpace.com Logo"
          loading="lazy"
        />
      </picture>
    </a>
  );
};

export default Logo;
